import { IOrganDetail } from "../../views/masterDataService/organization/organizationTypes";

export enum SearchTypeEnum {
    'Input' = 'input',
    'Select' = 'select',
    'Datepicker' = 'datepicker',
    'RangePicker' = 'rangePicker',
    "TreeSelect" = 'treeSelect'
}

export type ITreeSelectData = {
    title: string,
    value: string,
    children: ITreeSelectData[]
}

export interface ISearchValue {
    [propName: string]: string | number | [string, string]
}

export interface ISearchField {
    fieldName: string;
    type: SearchTypeEnum;
    placeholder?: string | string[];
    showTime?: Object | boolean;
    format?: string;
    xxl?: number;
    span?: number;
    disabled?: boolean;
    options?: { label: string, value: any, [key: string]: any }[],
    [key: string]: any
}

export interface ISearchProp {
    title: string | JSX.Element;
    triggerSearch?: boolean,
    searchFields?: ISearchField[],
    searchMoreFields?: ISearchField[],
    searchValues?: ISearchValue,
    onChange?: (arg: ISearchValue) => void
    handleReset?: () => void;
    handleSearch?: () => void;
    [key: string]: any

}